import { render, staticRenderFns } from "./EstruturaTabela.vue?vue&type=template&id=c145981c&lang=html&"
import script from "./EstruturaTabela.vue?vue&type=script&lang=js&"
export * from "./EstruturaTabela.vue?vue&type=script&lang=js&"
import style0 from "./EstruturaTabela.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/estrutura-usuario/EstruturaTabela.vue
// module id = 1392
// module chunks = 28